import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "error", "submitButton", "submitButtonWrapper"]
    static values = { required: Boolean }

    connect() {
        this.validate()
    }

    toggle() {
        this.validate()
    }

    submit(event) {
        if (this.requiredValue && !this.hasValidSelection()) {
            event.preventDefault()
            this.showError()
            return false
        }
    }

    validate() {
        if (this.requiredValue && !this.hasValidSelection()) {
            this.showError()
            this.disableSubmit()
        } else {
            this.hideError()
            this.enableSubmit()
        }
    }

    hasValidSelection() {
        const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked)
        return checkedBoxes.length > 0
    }

    showError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.remove("d-none")
        }
    }

    hideError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.add("d-none")
        }
    }

    disableSubmit() {
        // Disable the submit button and add a tooltip with our error.
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = true
            this.submitButtonTarget.classList.add("disabled")
        }

        if (this.hasSubmitButtonWrapperTarget) {
            if (typeof bootstrap !== 'undefined' && this.submitButtonWrapperTarget._tooltip) {
                this.submitButtonWrapperTarget._tooltip.dispose()
            }

            this.submitButtonWrapperTarget.setAttribute("data-bs-toggle", "tooltip")
            this.submitButtonWrapperTarget.setAttribute("data-bs-placement", "top")
            this.submitButtonWrapperTarget.setAttribute("data-bs-title", "Please select at least one type of animal you work with")
            this.submitButtonWrapperTarget.setAttribute("title", "Please select at least one type of animal you work with")
            if (typeof bootstrap !== 'undefined') {
                new bootstrap.Tooltip(this.submitButtonWrapperTarget)
            }
        }
    }

    enableSubmit() {
        // Enable the submit button and remove the tooltip.
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = false
            this.submitButtonTarget.classList.remove("disabled")
        }

        if (this.hasSubmitButtonWrapperTarget) {
            if (typeof bootstrap !== 'undefined') {
                if (this.submitButtonWrapperTarget._tooltip) {
                    this.submitButtonWrapperTarget._tooltip.dispose()
                }
                const tooltipInstance = bootstrap.Tooltip.getInstance(this.submitButtonWrapperTarget)
                if (tooltipInstance) {
                    tooltipInstance.dispose()
                }
            }

            this.submitButtonWrapperTarget.removeAttribute("data-bs-toggle")
            this.submitButtonWrapperTarget.removeAttribute("data-bs-placement")
            this.submitButtonWrapperTarget.removeAttribute("data-bs-title")
            this.submitButtonWrapperTarget.removeAttribute("data-bs-original-title")
            this.submitButtonWrapperTarget.removeAttribute("title")
            this.submitButtonWrapperTarget.removeAttribute("aria-label")

            const existingTooltips = document.querySelectorAll('.tooltip')
            existingTooltips.forEach(tooltip => tooltip.remove())
        }
    }
}
